/* eslint-disable no-undef */
import { gsap } from 'gsap';

const closeSubNav = (e) => {
  const mq = window.matchMedia('(max-width: 1023px)');
  const listItem = e.target.closest('li');

  // make sure you have the li and get sub nav
  const subNav = listItem.querySelector('.sub-menu-wrap');
  subNav.classList.remove('isActive');

  if (mq.matches) {
    gsap.to(subNav, { duration: 0.3, maxHeight: '0' });

    setTimeout(() => {
      listItem.classList.remove('active');
      listItem.classList.add('inactive');
    }, 300);
  }
};

const parentClicked = (e) => {
  const mq = window.matchMedia('(max-width: 1023px)');

  // make sure you have the li
  const listItem = e.target.closest('li');
  if (listItem.classList.contains('active')) {
    closeSubNav(e);
    return;
  }

  if (mq.matches) {
    listItem.classList.remove('inactive');
    listItem.classList.add('active');
  }

  // get sub nav
  const subNav = listItem.querySelector('.sub-menu-wrap');
  if (subNav) {
    subNav.classList.add('isActive');
    if (mq.matches) {
      gsap.to(subNav, { duration: 1, maxHeight: '500px' });
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.getElementById('primaryNav-ventures');
  const toggle = document.getElementById('primaryNav-toggle');
  const parentNavItems = document.getElementsByClassName('menu-item-has-children');
  const subMenuCloseButtons = document.getElementsByClassName('sub-menu-close');
  let open = false;
  let count = 0;
  const openText = document.getElementById('primaryNav-toggle-openText');
  const closeText = document.getElementById('primaryNav-toggle-closeText');

  if (!toggle) {
    return;
  }

  if (mobileNav === null) {
    return;
  }

  toggle.onclick = () => {
    open = !open;

    toggle.classList.toggle('active');
    document.getElementsByTagName('html')[0].classList.toggle('no-scroll');
    document.getElementsByTagName('html')[0].classList.toggle('mobile-open');

    if (count > 0) {
      toggle.classList.toggle('closed');
    }

    count += 1;

    if (closeText !== null) {
      gsap.to(closeText, { duration: 0, autoAlpha: 1, y: '-100%' });
    }

    if (open) {
      gsap.to(mobileNav, { duration: 0.3, autoAlpha: 1, display: 'block' });
      if (openText !== null && closeText !== null) {
        gsap.to(openText, { duration: 0.3, autoAlpha: 0, y: '100%', display: 'none' });
        gsap.to(closeText, { duration: 0.3, autoAlpha: 1, y: '0%', display: 'block' });
      }
    } else {
      gsap.to(mobileNav, { duration: 0.3, autoAlpha: 0, display: 'none' });
      if (openText !== null && closeText !== null) {
        gsap.to(closeText, { duration: 0.3, autoAlpha: 0, y: '-100%', display: 'none' });
        gsap.to(openText, { duration: 0.3, autoAlpha: 1, y: '0%', display: 'block' });
      }
    }
  };

  for (let i = 0; i < parentNavItems.length; i += 1) {
    parentNavItems[i].addEventListener('click', parentClicked);
  }

  for (let j = 0; j < subMenuCloseButtons.length; j += 1) {
    subMenuCloseButtons[j].addEventListener('click', closeSubNav);
  }

  // Remove transparent header on scroll
  const header = document.querySelector('.site-header');
  const scrollPositionOnLoad = window.pageYOffset;

  if (header.classList.contains('site-header--ventures-transparent')) {
    if (scrollPositionOnLoad > 0) {
      header.classList.remove('site-header--ventures-transparent');
    }

    window.addEventListener('scroll', () => {
      const scrollPosition = window.pageYOffset;

      if (scrollPosition > 0) {
        header.classList.remove('site-header--ventures-transparent');
      } else {
        header.classList.add('site-header--ventures-transparent');
      }
    });
  }
});
